import React from "react";
import { Link } from "./link";
import { normalizeRelativePath } from "../utility/paths";

const Pages = ({ item, region }) => {
  const isRussiaBox = item.some((el) => el.content?.russiaCode);
  let pages;

  if (isRussiaBox) {
    if (region && region !== "not available") {
      pages = item.filter(
        (el) =>
          !el.content?.russiaCode ||
          el.content?.russiaCode.split(",").some((code) => code === region)
      );
    } else {
      pages = item.filter(
        (el) =>
          !el.content?.russiaCode ||
          el.content?.russiaCode.split(",").some((code) => code === "VOR")
      );
    }
  } else {
    pages = item;
  }

  return pages.map((page, j) => (
    <li key={j}>
      {page.content.slug && page.content.slug ? (
        <Link
          to={normalizeRelativePath(page.content.slug)}
          target={
            page?.content?.target && page?.content?.target?.length > 0
              ? page.content.target?.[0]
              : ""
          }
          className="footer__link"
        >
          {!!page?.useCustomName && page?.name ? page.name : page.content.liferayFields?.title}
        </Link>
      ) : (
        <Link
          to={page.content.externalLink}
          target={
            page?.content?.target && page?.content?.target?.length > 0
              ? page.content.target?.[0]
              : ""
          }
          rel={
            page.content.target && page.content.target?.[0] === "_blank"
              ? "noopener noreferrer"
              : ""
          }
          className="footer__link"
        >
          {!!page?.useCustomName && page?.name ? page.name : page.content.liferayFields?.title}
        </Link>
      )}
    </li>
  ));
};

export default Pages;
